module.exports = __webpack_public_path__ + "static/media/fratelli.e91303ee.jpg";